module.exports = __webpack_public_path__ + "media/docs/student_upload_template-2ec2b891.csv";